import { Box, Button, Card, CardContent, Divider, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Tabs from "../../components/tabs/tabs";
import CustomIcon from "../../components/customIcon";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { TransactionsTable } from "../../components/tables";
import userServices from "../../services/userServices";
import store from "../../redux/store";
import CanceledTransactions from "../portfolio/CanceledTransactions";
import TokenTransfer from "../../components/tokenTransfer";
import tokenTransferServices from "../../services/tokenTransferServices";
export default function Transactions({ title, status, areTransactionsThere, setAreTransactionsThere }){
    const { watchlist } = useSelector(state=>state.user);
    const location = useLocation();
    const navigate = useNavigate();
    const [transactionsDetails,setData] = useState([]);
    const [peerToPeerTransactions,setPeerToPeerTransactions] = useState([]);
    const [url,setUrl] = useState(null);
    const [loading,setLoading] = useState(true);
    const investorId = store.getState().user?.data?._id;

    const getTransactionDetails = async(investorId) =>{
        setLoading(true);
        try {
            let res = await userServices.getATransactionDetails({investorId,status:status});

            if(res && res.success && res.data?.length >0){
                if(status){
                    setAreTransactionsThere(true)
                }
                res.data[0].url = res.url;
                setData(res.data)
            } else {
                setData([])
            }
        } finally {
            setLoading(false);
        }
    }
    const getTokenTransferTransactions = async() =>{
        let res = await tokenTransferServices.getTokenTransferTransactions(investorId);
        if(res && res.success && res.data){
            setPeerToPeerTransactions(res.data)
            setUrl(res.url)
        }
    }

    useEffect(()=>{
        if(!investorId) {
            setLoading(false);
            return;
        }
        getTransactionDetails(investorId);
        getTokenTransferTransactions();
    },[investorId]);
    

    const tabs = [
        {
            name:title || "Active",
            tab:<TransactionsTable transactionsDetails={transactionsDetails} getTransactionDetails={getTransactionDetails} title={title} tableLoading={loading}/>
        },
        {
            name:title || "Cancelled",
            tab:<CanceledTransactions title={title}/>
        },
        {
            name:title || "Token Tranfer Logs",
            tab:<TokenTransfer peerToPeerTransactions={peerToPeerTransactions} getTokenTransferTransactions={getTokenTransferTransactions} title={title} url={url}/>
        }
    ];

    const [activeTab,setActiveTab] = useState(0);
    
    // Map tab names to indices for URL query parameter support
    const tabNameMap = {
        'active': 0,
        'cancel': 1,
        'transfer': 2,
    };

    // Read tab from URL query parameter on mount and when location changes
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const tabParam = params.get("tab");
        
        if (tabParam) {
            // Try to parse as number first (0, 1, 2)
            const tabIndex = parseInt(tabParam, 10);
            const maxTabs = 3; // Active, Cancelled, Token Transfer Logs
            if (!isNaN(tabIndex) && tabIndex >= 0 && tabIndex < maxTabs) {
                setActiveTab(tabIndex);
            } 
            // Otherwise, try to match by name (active, cancel, transfer, etc.)
            else {
                const lowerTabParam = tabParam.toLowerCase();
                if (tabNameMap.hasOwnProperty(lowerTabParam)) {
                    setActiveTab(tabNameMap[lowerTabParam]);
                }
            }
        }
    }, [location.search]);

    const handleTabClick = (index) => {
        setActiveTab(index);
        // Update URL with tab parameter without page reload
        const tabNames = ['active', 'cancel', 'transfer'];
        const params = new URLSearchParams(location.search);
        params.set('tab', tabNames[index] || index.toString());
        navigate(`${location.pathname}?${params.toString()}`, { replace: true });
    }
    return(
        <Box>
                <Card 
                sx={{mt:{md:5,xs:3}}}
                >
                <Stack>

                    <Box sx={{padding:"10px"}}>
                    { transactionsDetails && 
                        <Tabs activeTab={activeTab} tabs={tabs} onClick={handleTabClick} />
                    }
                    <Divider sx={{
                            width:"calc(100% + 80px)",
                        }} />
                    </Box>
                    
                    <Box >
                        {
                            
                             tabs[activeTab]?.tab
                        }
                    </Box>
                </Stack>
                </Card>

            {/* } */}
        </Box>
    )
}

const EmptyTableState = ({showAction=false,title,subtitle}) =>{
    const navigate = useNavigate();
    return(
        <Box
        sx={{
            flex:1,
            width:"100%",
            // bgcolor:"red"
        }}
    >
        <Stack height={"100%"} direction={"column"} alignItems={"center"} justifyContent={"center"}>
            <Box 
                sx={{
                    width:{md:160,xs:88},height:{md:160,xs:88},
                    bgcolor:"primary.light",
                    borderRadius:"100%",
                    display:"flex",
                    justifyContent:"center",
                    alignItems:"center",
                    mt:{md:0,xs:3}
                }}
            >
                <CustomIcon name="file-document" sx={{bgcolor:"primary.main",width:{md:72,xs:32},height:{md:72,xs:32},}} />
            </Box>
            <Typography sx={{fontSize:"28px",fontWeight:500,mt:{md:4,xs:3},mb:{md:1.5,xs:0.5}}}>{title}</Typography>
            <Typography variant="subtitle1" sx={{fontSize:"16px",fontWeight:300,mb:{md:3,xs:2}}}>{subtitle}</Typography>
            {showAction && <Button onClick={()=>navigate("/dashboard")} sx={{mb:{md:0,xs:3}}} variant="contained">Explore Properties to invest</Button>}
        </Stack>
    </Box>
    )
}